// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"732":"WhatsAppNumber","983":"KakaoTalkNumber"}[chunkId] || chunkId) + "." + {"79":"f3594df3","648":"de1c85c4","732":"8d4e078c","983":"8d4e078c"}[chunkId] + ".css";
};